// Returns the internationalized human-readable string for the given type.
import { C1ChipProps } from 'c1ui/components/C1Chip'
import { AppUserType } from 'pbts/c1/api/accessreview/v1/accessreview'
import { UserStatus } from 'pbts/c1/api/user/v1/user'
import { IntlShape } from 'react-intl'

export const userStatusToIntl = (type: UserStatus | undefined, intl: IntlShape): string => {
    const unknown = intl.formatMessage({ id: 'Components_UserView_Status_Unknown', defaultMessage: 'Unknown' })
    if (!type) {
        return unknown
    }
    switch (type) {
        case UserStatus.ENABLED:
            return intl.formatMessage({ id: 'Components_UserView_Status_Enabled', defaultMessage: 'Active' })
        case UserStatus.DISABLED:
            return intl.formatMessage({
                id: 'Components_UserView_Status_Disabled',
                defaultMessage: 'Suspended',
            })
        case UserStatus.DELETED:
            return intl.formatMessage({
                id: 'Components_UserView_Status_Deleted',
                defaultMessage: 'Deleted',
            })
        default:
            return unknown
    }
}

export const userStatusToIdentifier = (
    type: UserStatus | undefined,
    intl: IntlShape,
): Pick<C1ChipProps, 'color' | 'label'> => {
    const userStatusToChipColor = (userStatusType: UserStatus | undefined): Pick<C1ChipProps, 'color'> => {
        switch (userStatusType) {
            case UserStatus.ENABLED:
                return { color: 'success' }
            case UserStatus.DISABLED:
                return { color: 'warning' }
            case UserStatus.DELETED:
                return { color: 'error' }
            case UserStatus.UNKNOWN:
                return { color: 'info' }
            default:
                return { color: 'warning' }
        }
    }

    return {
        label: userStatusToIntl(type, intl),
        ...userStatusToChipColor(type),
    }
}

export const userStatusToIntlByStatusKey = (key: string, intl: IntlShape): string => {
    const status: UserStatus = UserStatus[key]
    return userStatusToIntl(status, intl)
}

export const appUserTypeToIntl = (au: AppUserType, intl: IntlShape): string => {
    switch (au) {
        case AppUserType.USER:
            return intl.formatMessage({ id: 'app_user_type_user', defaultMessage: 'User' })
        case AppUserType.SERVICE_ACCOUNT:
            return intl.formatMessage({ id: 'app_user_type_service_account', defaultMessage: 'Service account' })
        case AppUserType.SYSTEM_ACCOUNT:
            return intl.formatMessage({ id: 'app_user_type_system_account', defaultMessage: 'System account' })
        case AppUserType.UNSPECIFIED:
            return intl.formatMessage({ id: 'app_user_type_unspecified', defaultMessage: 'Unspecified' })
        default:
            return intl.formatMessage({ id: 'app_user_type_unknown', defaultMessage: 'Unknown' })
    }
}

export const appUserTypeToString = (option: AppUserType): string | undefined => {
    for (const key in AppUserType) {
        if ((AppUserType[key] as unknown as number) === option) {
            return key
        }
    }
    return undefined
}
